<script lang="ts">
    import { kirbyUrl } from "../../../../api/hooks/config-client"

    interface Props {
        path: string
        teaser: string
        title: string
        hashtags?: string[]
        image?: string
    }
    let { path, teaser, title, hashtags, image }: Props = $props()
    function shareOnPlatform(
        platform: string,
        path: string,
        teaser: string,
        titlep: string,
        hashtagsp: string[],
        image: string
    ) {
        const url = `${window.location.origin}${path}`
        const encodedUrl = encodeURIComponent(url)
        const title = encodeURIComponent(titlep)
        const description = encodeURIComponent(teaser)
        const hashtags = hashtagsp ? hashtagsp.join(",") : ""
        let shareUrl = ""

        switch (platform) {
            case "facebook":
                shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
                break
            case "twitter":
                shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${title}&hashtags=${hashtags}`
                break
            case "linkedin":
                shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${title}&summary=${description}&source=Stiftung%20Familienunternehmen`
                break
            default:
                return
        }

        openShareWindow(shareUrl)
    }

    // Utility function to open a centered share window
    function openShareWindow(shareUrl: string) {
        const width = 600
        const height = 400
        const left = (window.screen.width - width) / 2
        const top = (window.screen.height - height) / 2

        window.open(
            shareUrl,
            "_blank",
            `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
        )
    }
</script>

<button
    onclick={() => shareOnPlatform("linkedin", path, teaser, title, hashtags, image)}
    class="linkedin"
    aria-label="Share on LinkedIn"
>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
            d="M5.25 12.75V7.5M8.25 12.75V10.3125M8.25 10.3125V7.5M8.25 10.3125C8.25 7.5 12.75 7.5 12.75 10.3125V12.75M5.25 5.2575L5.2575 5.24925M15.75 6V12C15.75 12.9946 15.3549 13.9484 14.6517 14.6517C13.9484 15.3549 12.9946 15.75 12 15.75H6C5.00544 15.75 4.05161 15.3549 3.34835 14.6517C2.64509 13.9484 2.25 12.9946 2.25 12V6C2.25 5.00544 2.64509 4.05161 3.34835 3.34835C4.05161 2.64509 5.00544 2.25 6 2.25H12C12.9946 2.25 13.9484 2.64509 14.6517 3.34835C15.3549 4.05161 15.75 5.00544 15.75 6Z"
            stroke="#242220"
            stroke-linecap="round"
            stroke-linejoin="round"
        ></path>
    </svg>
</button>
<button
    onclick={() => shareOnPlatform("twitter", path, teaser, title, hashtags, image)}
    class="twitter"
    aria-label="Share on Twitter"
>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
            d="M15 2.25L2.99998 15.75M12.615 15.576L2.81473 2.976C2.76308 2.90948 2.73113 2.8298 2.72251 2.74603C2.7139 2.66225 2.72897 2.57774 2.76601 2.5021C2.80304 2.42646 2.86056 2.36274 2.93202 2.31817C3.00348 2.2736 3.08601 2.24999 3.17023 2.25H5.03023C5.09871 2.2501 5.16625 2.26583 5.22773 2.29598C5.2892 2.32613 5.34299 2.36992 5.38498 2.424L15.1852 15.024C15.2369 15.0905 15.2688 15.1702 15.2775 15.254C15.2861 15.3377 15.271 15.4223 15.234 15.4979C15.1969 15.5735 15.1394 15.6373 15.0679 15.6818C14.9965 15.7264 14.914 15.75 14.8297 15.75H12.9697C12.9013 15.7499 12.8337 15.7342 12.7722 15.704C12.7108 15.6739 12.657 15.6301 12.615 15.576Z"
            stroke="#242220"
            stroke-linecap="round"
        ></path>
    </svg>
</button>

<!--
<button--
    onclick={() => shareOnPlatform("facebook", path, teaser, title, hashtags, image)}
    class="facebook"
    aria-label="Share on Facebook"
>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
            d="M12.75 1.5H10.5C9.50543 1.5 8.55158 1.89508 7.84838 2.59835C7.14509 3.30161 6.75 4.25544 6.75 5.25V7.5H4.5V10.5H6.75V16.5H9.75V10.5H12L12.75 7.5H9.75V5.25C9.75 5.05109 9.82905 4.86032 9.96968 4.71967C10.1103 4.57902 10.3011 4.5 10.5 4.5H12.75V1.5Z"
            stroke="#242220"
            stroke-linecap="round"
            stroke-linejoin="round"
        ></path>
    </svg>
</button-->

<style lang="less">
    button {
        display: flex;
        align-items: center;
        svg {
            height: 18px;
            path {
                transition: all 0.3s ease-in-out;
            }
        }
        &:hover {
            path {
                stroke: var(--brand-100);
            }
        }
    }
</style>
